module.exports = __webpack_public_path__ + "img/C03TechBowmanChampion_ua.9141f9da.webp";